import {
  countries
} from '../helpers/countries';
import {
  applicantFields,
  legalGuardianFields,
  primaryApplicantStudentFields,
  premiumField,
  studentNumberFields,
  overridePremiumFields,
  splitPolicyButton,
} from '../helpers/fields';

import * as fieldGroups from '../helpers/fieldGroups';

const clientName = 'lloydscomprehensiveplus';

export function expandedGroups() {
  return [
    fieldGroups.policyGroup(clientName, 'Referrer'),
    fieldGroups.primaryApplicantDetailsGroup(clientName),
    fieldGroups.emailNotificationGroup(),
    fieldGroups.feeRefundGroup(),
    fieldGroups.contactDetailsGroup(clientName),
    fieldGroups.dependentDetailsGroup(clientName),
    fieldGroups.coverageDetailsGroup(clientName),
    fieldGroups.pmqGroup(),
    fieldGroups.paymentGroup(clientName),
    fieldGroups.fulfillmentGroup(),
    fieldGroups.renewalGroup(),
    fieldGroups.historyGroup(),
    fieldGroups.associatedGroup(),
    fieldGroups.notesGroup(),
    fieldGroups.claimsGroup(),
    fieldGroups.viewMemberPortalGroup(),
    fieldGroups.magentaAccessGroup(),
  ];
}

export function fields() {
  return {
    primary_applicant_fields: [
      ...primaryApplicantStudentFields(),
    ],
    contact_details_fields: [
      ...legalGuardianFields(false)
    ],
    dependent_fields: [
      ...applicantFields('*', [{
          value: 'dependent',
          text: 'Dependent Child'
        },
        {
          value: 'parent',
          text: 'Parent/Guardian'
        },
        {
          value: 'spouse',
          text: 'Spouse'
        },
        {
          value: 'sibling',
          text: 'Sibling'
        }
      ]),
      ...studentNumberFields('*'),
      ...splitPolicyButton()
    ],
    coverage_fields: [
      {
        key_path: ['application', 'additional_data', 'existing_policy'],
        as: 'Previous Policy Number',
        is_static_by_default: true,
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'existing_policy'],
          value: undefined
        }]
      },
      {
        key_path: ['application', 'additional_data', 'country_of_origin'],
        as: 'Country of Origin',
        type: 'dropdown',
        options: countries()
      },
      {
        key_path: ['application', 'additional_data', 'other_plan'],
        as: 'Other Insurance',
        type: 'dropdown',
        options: [
          { value: 'yes', text: 'Yes' },
          { value: 'no', text: 'No' }
        ],
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'other_plan'],
          value: undefined
        }]
      },
      {
        key_path: ['application', 'additional_data', 'name_of_other_plan'],
        as: 'Name of Other Plan',
        show_if: [{
          key_path: ['application', 'additional_data', 'other_plan'],
          value: 'yes'
        }]
      },
      {
        key_path: ['application', 'additional_data', 'aar_option'],
        as: 'Adventure Activities Rider',
        type: 'dropdown',
        is_static_by_default: true,
        options: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ],
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'aar_option'],
          value: undefined
        }]
      },
      {
        key_path: ['application', 'additional_data', 'enhanced_rider_option'],
        as: 'Comprehensive+ Enhanced Rider',
        type: 'dropdown',
        is_static_by_default: true,
        options: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ],
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'enhanced_rider_option'],
          value: undefined
        }]
      }
    ],
    payment_fields: overridePremiumFields()
  }
}



// WEBPACK FOOTER //
// ./src/clients/lloydscomprehensiveplus.js